export enum ReviewResponse {
  BestPracticeResponse = 'bestPracticeResponse',
  InfoOnLateResponse = 'infoOnLateResponse',
}
